<div>
  <div #hybridGoogleMap id="hybridGoogleMap" (contextmenu)="onRightClick($event)"
  class="google-map {{getMapClass()}}"> </div>

  @if (mapType === 0) {
      <aa-traffic-alert-car-park #mapOptTrafficAlertCarPark id='mapOptTrafficAlertCarPark'></aa-traffic-alert-car-park>
      <aa-google-context-menu></aa-google-context-menu>
  }

  @if (mapType === 1) {
      <google-map-traffic-widget></google-map-traffic-widget>
  }

</div>